import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete, Edit } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import { useSelector } from "react-redux";
import { AddCircle, DocumentDownload, Edit2, Trash } from "iconsax-react";
import CustomPagination from "../../Utils/CustomPagination";
import { filter } from "lodash";

function List(props) {
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [data, setData] = useState({});
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const currentYear = new Date().getFullYear();
  const yearList = Array.from(
    { length: currentYear - 2022 },
    (_, i) => currentYear - i
  );
  const [selectedYear, setSelectedYear] = useState(currentYear.toString());

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: "Employee",
      selector: (row) => row.username,
    },
    {
      name: "Leave Type",
      selector: (row) => row.leave_name,
    },
    {
      name: "Year",
      selector: (row) => row.year,
    },
    {
      name: "Leave Balance",
      selector: (row) => row.leave_balance,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          {utils.hasPermission(
            primaryMenuRes,
            "Leave Balance",
            "leave_balance.edit"
          ) && (
            <RB.Button className="btn-flat" onClick={handelEdit(row)}>
              <Edit2 />
            </RB.Button>
          )}
          &nbsp;
          {/* {utils.hasPermission(
            primaryMenuRes,
            "Leave Balance",
            "leave_balance.delete"
          ) && (
            <RB.Button
              className="btn-flat"
              onClick={showDelete(row)}
            >
              <Trash />
            </RB.Button>
          )} */}
        </>
      ),

      omit:
        !utils.hasPermission(
          primaryMenuRes,
          "Leave Balance",
          "leave_balance.edit"
        ) &&
        !utils.hasPermission(
          primaryMenuRes,
          "Leave Balance",
          "leave_balance.delete"
        ),
    },
  ];

  useEffect(() => {
    getLeaveBalanceList();
  }, [page, filterText, selectedYear]);

  const getLeaveBalanceList = () => {
    utils
      .callAPI(
        "get",
        `/leave/leave-balance/list?page=${page}&per_page=${countPerPage}&search=${filterText}&year=${selectedYear}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setData(res);
        } else {
          setData([]);
        }
      })
      .catch((err) => {
        setData([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    // Swal({
    //     title: 'Are you sure?',
    //     text: 'Once deleted, you will not be able to recover this imaginary file!',
    //     icon: 'warning',
    //     buttons: ["No", "Yes"],
    //     dangerMode: true,
    //   })
    //   .then((willDelete) => {
    //     if (willDelete) {

    //     }
    //   });

    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("get", `/leave/leave-balance/delete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getLeaveBalanceList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <div className="custom-subheader d-flex align-items-center justify-content-end flex-wrap gap-2">
        <RB.Form.Select
          name="year"
          value={selectedYear}
          onChange={(e) => {
            setSelectedYear(e.target.value);
            setPage(1);
          }}
          className="year-select"
        >
          <option value="">Select Year</option>
          {yearList.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </RB.Form.Select>

        <div className="filter-input-wrapper">
          <FilterComponent
            onFilter={(e) => setFilterText(e.target.value)}
            onClear={handleClear}
            filterText={filterText}
          />
        </div>
      </div>
    );
  }, [filterText, resetPaginationToggle, selectedYear]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleDownload = () => {
    // Get all data (no pagination, include current filters)
    utils
      .callAPI(
        "get",
        `/leave/leave-balance/list?page=0&per_page=0&search=${filterText}&year=${selectedYear}`
      )
      .then((res) => {
        if (res && Array.isArray(res.result) && res.result.length > 0) {
          // ✅ CSV header (same fields as table)
          const csvHeader = `Sr.No.,Employee,Leave Type,Year,Leave Balance`;

          // ✅ Map data rows
          const csvRows = res.result.map((item, index) => {
            return [
              index + 1,
              `"${item.username || ""}"`,
              `"${item.leave_name || ""}"`,
              `"${item.year || ""}"`,
              `"${item.leave_balance || ""}"`,
            ].join(",");
          });

          // ✅ Join all into CSV string
          const csvContent = [csvHeader, ...csvRows].join("\n");

          // ✅ Create downloadable blob
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });
          const link = document.createElement("a");

          // Add timestamp to filename
          const timestamp = new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", "_")
            .replace(/:/g, "-");

          link.href = URL.createObjectURL(blob);
          link.download = `Leave_Balance_List_${timestamp}.csv`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((err) => {});
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <div className="floating-btns-holder-artisan">
          <a
            href
            className={`${
              data.result?.length == 0 ? "disabled" : ""
            } btn btn-primary btn-circle me-2`}
            variant="primary"
            onClick={() => handleDownload()}
          >
            <DocumentDownload />
          </a>
          {utils.hasPermission(
            primaryMenuRes,
            "Leave Balance",
            "leave_balance.create"
          ) && (
            <a
              href
              className="btn btn-dark btn-circle"
              variant="dark"
              onClick={handleAddClick}
            >
              <AddCircle />
            </a>
          )}
        </div>
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action"></div>
        </RB.Card.Header>
        <RB.Card.Body>
          {/* <RB.Row>
            <div className="mb-3">
              <RB.FloatingLabel
                controlId="year"
                label="Year"
                className="floating-label-fancy"
              >
                <RB.Form.Select
                  name="year"
                  value={selectedYear}
                  onChange={(e) => {
                    setSelectedYear(e.target.value);
                    setPage(1); // reset to page 1 if filtering
                  }}
                >
                  <option value="">All Years</option>
                  {yearList.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </RB.Form.Select>
              </RB.FloatingLabel>
            </div>
          </RB.Row> */}
          {utils.hasPermission(
            primaryMenuRes,
            "Leave Balance",
            "leave_balance.view"
          ) && (
            <DataTable
              columns={columns}
              data={data.result}
              highlightOnHover
              responsive
              pagination
              striped
              paginationServer
              paginationTotalRows={data.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              paginationComponent={() => (
                <CustomPagination
                  currentPage={page}
                  totalRows={data.total}
                  rowsPerPage={countPerPage}
                  onPageChange={handlePageChange}
                />
              )}
              onChangePage={(page) => setPage(page)}
              persistTableHead
              // subHeader
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              subHeader
              subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
